import { render, staticRenderFns } from "./BtInputField.vue?vue&type=template&id=dd1bfee4&scoped=true&lang=pug"
import script from "./BtInputField.vue?vue&type=script&lang=js"
export * from "./BtInputField.vue?vue&type=script&lang=js"
import style0 from "./BtInputField.vue?vue&type=style&index=0&id=dd1bfee4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd1bfee4",
  null
  
)

export default component.exports